import { render, staticRenderFns } from "./FbImg.vue?vue&type=template&id=423766c6"
import script from "./FbImg.vue?vue&type=script&lang=js"
export * from "./FbImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports